module.exports = __webpack_public_path__ + "assets/img/img336.e7633db4.png";